"use client";
import Link from "next/link";
import { Button } from "@/components";
import {
  DescriptionDetails,
  DescriptionList,
  DescriptionTerm,
} from "@/components/atoms/description-list";
import { formatCurrency } from "@/lib";
import useSWR from "swr";
import { AppSettings } from "@/app/(hub)/settings/application/types";
import { getAppSettings } from "@/app/(hub)/settings/application/services";
import { Skeleton } from "antd";

export default function ShippingRates() {
  const { data: shippingRates, isLoading } = useSWR<
    | AppSettings
    | {
        ok: false;
        error: string;
      }
  >("/api/shipping-rates", getAppSettings);

  return (
    <div className="pt-3 flex flex-col space-y-4">
      <div className="space-y-1">
        <h2 className="text-sm font-semibold">Exchange Rate</h2>
        {isLoading && (
          <DescriptionList>
            <DescriptionTerm>Dollar to Naira</DescriptionTerm>
            <DescriptionDetails>
              {isLoading ? (
                <Skeleton.Input className="h-4 w-24" />
              ) : (
                formatCurrency(
                  ((shippingRates as AppSettings)?.dollarToNaira ?? 0) * 100,
                  "Naira",
                )
              )}
            </DescriptionDetails>
            <DescriptionTerm>RMB to Naira</DescriptionTerm>
            <DescriptionDetails>
              {isLoading ? (
                <Skeleton.Input className="h-4 w-24" />
              ) : (
                formatCurrency(
                  ((shippingRates as AppSettings)?.yuanToNaira ?? 0) * 100,
                  "Naira",
                )
              )}
            </DescriptionDetails>
          </DescriptionList>
        )}
      </div>
      <div className="space-y-1">
        <h2 className="text-sm font-semibold">Air Cargo Rates</h2>
        {shippingRates && (
          <DescriptionList>
            <DescriptionTerm>Normal goods</DescriptionTerm>
            <DescriptionDetails>
              {isLoading ? (
                <Skeleton.Input className="h-4 w-24" />
              ) : (
                `$${(shippingRates as AppSettings)?.kgBasePrice ?? 0} Per KG arrives in 7 to 14 days`
              )}
            </DescriptionDetails>
            <DescriptionTerm>Sensitive goods</DescriptionTerm>
            <DescriptionDetails>
              {isLoading ? (
                <Skeleton.Input className="h-4 w-24" />
              ) : (
                `$${(shippingRates as AppSettings)?.kgBasePriceDangerousGoods ?? 0} Per KG arrives in 14 to 21 days`
              )}
            </DescriptionDetails>
          </DescriptionList>
        )}
      </div>
      <div className="space-y-1">
        <h2 className="text-sm font-semibold">Sea Cargo Rates</h2>
        {shippingRates && (
          <DescriptionList>
            <DescriptionTerm>Normal goods</DescriptionTerm>
            <DescriptionDetails>
              {isLoading ? (
                <Skeleton.Input className="h-4 w-24" />
              ) : (
                `${formatCurrency(((shippingRates as AppSettings)?.cbmBasePrice ?? 0) * 100, "Dollar")} Per CBM arrives in 45 to 70 days`
              )}
            </DescriptionDetails>
            <DescriptionTerm>Sensitive goods</DescriptionTerm>
            <DescriptionDetails>
              {isLoading ? (
                <Skeleton.Input className="h-4 w-24" />
              ) : (
                `${formatCurrency(((shippingRates as AppSettings)?.cbmBasePriceDangerousGoods ?? 0) * 100, "Dollar")} Per CBM arrives in 45 to 70 days`
              )}
            </DescriptionDetails>
          </DescriptionList>
        )}
      </div>
      <Link href="/procure/rates" target="_blank">
        <Button outline>View full rates</Button>
      </Link>
    </div>
  );
}
